import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from 'src/app/shared/services/entities-service.service';

@Component({
  selector: 'app-vehicle-insight',
  templateUrl: './vehicle-insight.component.html',
  styleUrls: ['./vehicle-insight.component.css']
})
export class VehicleInsightComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() tabData: any;
  attributeDataList: any[] = [];
  lineData: any = [];
  statisticsData: any[] = [];
  masterLeafletData: any = [];

  private _leftSideStatData: any = {};
  private _dummyData: any = [
    {
      value: 10,
      date: "2023-03-18T09:00:00+0530"
    },
    {
      value: 12,
      date: "2023-03-18T10:00:00+0530"
    },
    {
      value: 15,
      date: "2023-03-18T11:00:00+0530"
    },
    {
      value: 17,
      date: "2023-03-18T12:00:00+0530"
    },
    {
      value: 19,
      date: "2023-03-18T13:00:00+0530"
    }
  ];
  private _tabIndex: any;
  private _entityInsightsStatisticsSubscription: Subscription;
  private _entityInsightsAttributeSubscription: Subscription;
  
  // attributeData: any = {};
 
  // masterLeafletData: any = [{
  //   polygonData: [
  //     [8.55781, 76.86691],
  //     [8.59312, 76.89266],
  //     [8.58633, 76.94380],
  //     [8.55306, 76.96027],
  //     [8.54084, 76.98361]
  //   ]
  // }];
 
  constructor(
    private _entityService: EntitiesServiceService,
    private _datePipe: DatePipe,
    private _service: ServicecallService
  ) { }
  ngAfterViewInit() { //dummy data
    // this.dummyData.forEach((element: any) => {
    let laneData = {
      x: this._dummyData?.map(({ date }) => date),
      y: this._dummyData?.map(({ value }) => value),
      mode: 'lines+markers',
      connectgaps: true,
      title: '',
      margin: {
        l: 30,
        r: 10,
        b: 30,
        t: 0
      },
      legend: true,
      name: ''
    };
    this.lineData.push(laneData);
    // });
    // let enitityCords = [
    //   {
    //     "lat": 8.537545346659485,
    //     "long": 76.88186293551199
    //   },
    //   {
    //     "lat": 8.537545346659485,
    //     "long": 76.88186293551199
    //   },
    //   {
    //     "lat": 8.537545346659485,
    //     "long": 76.88186293551199
    //   },
    //   {
    //     "lat": 8.537545346659485,
    //     "long": 76.88186293551199
    //   }];
    // this.masterLeafletData = [{
    //   polygonData: enitityCords.map(({ lat, long }) => { return [lat, long] })
    // }];
  }

  ngOnInit(): void {
    const requestData = {
      entityId: this.tabData?.entityId,
      from: this._datePipe.transform(new Date(new Date().setMinutes(new Date().getMinutes() - 15)), 'yyyy-MM-ddTHH:mm:ssZZ')
    }
    this._entityInsightsStatisticsSubscription = this._entityService.entityInsightsStatistics(requestData).subscribe((resp: any) => {
      if (resp['status']) {
        if (resp['response']['data'].length) {
          this._leftSideStatData = resp['response']['data'][0];
          // this._leftSideStatData = {
          //   "dataFrom": "2023-04-07T14:15:00+0800",
          //   "siteId": "63c0e2cd8fc6f2556af3d0c1",
          //   "entityId": "6375d1f593313eb9e965a9da",
          //   "attributes": [
          //     {
          //       "name": "totalDistance",
          //       "value": 140
          //     },
          //     {
          //       "name": "distanceInDuration",
          //       "value": 15
          //     },
          //     {
          //       "name": "coastingDistanceInDuration",
          //       "value": 15
          //     },
          //     {
          //       "name": "cruisingDistanceInDuration",
          //       "value": 15
          //     },
          //     {
          //       "name": "sweetspotDistanceInDuration",
          //       "value": 15
          //     },
          //     {
          //       "name": "topGearDistanceInDuration",
          //       "value": 15
          //     },
          //     {
          //       "name": "timeToService",
          //       "value": 15
          //     },
          //     {
          //       "name": "distanceToService",
          //       "value": 15
          //     },
          //     {
          //       "name": "costPerKmForTheRide",
          //       "value": 15
          //     },
          //     {
          //       "name": "mileageForRide",
          //       "value": 15
          //     },
          //     {
          //       "name": "rideScore",
          //       "value": 15
          //     },
          //     {
          //       "name": "rideScore",
          //       "value": 15
          //     },
          //     {
          //       "name": "idleFuel",
          //       "value": 15
          //     },
          //     {
          //       "name": "idleTime",
          //       "value": 15
          //     }
          //   ],
          //   "dataTill": "2023-04-07T14:29:59+0800"
          // };
          if (this._leftSideStatData) {
            this.statisticsData = [this._leftSideStatData.attributes?.find((item: any) => { return item?.name === 'Distance' }),
            this._leftSideStatData.attributes.find((item: any) => { return item?.name === 'rideScore' }),
            this._leftSideStatData.attributes.find((item: any) => { return item?.name === 'Coasting Distance' }),
            this._leftSideStatData.attributes.find((item: any) => { return item?.name === 'Cruising Distance' }),
            this._leftSideStatData.attributes.find((item: any) => { return item?.name === 'Sweetspot Distance' }),
            this._leftSideStatData.attributes.find((item: any) => { return item?.name === 'Top Gear Distance' }),
            this._leftSideStatData.attributes.find((item: any) => { return item?.name === 'Distance' })]
            this._getEntityInsightsAttribute();
          }
        } else {
          this._leftSideStatData = null;
        }
      } else {
        this._leftSideStatData = null;
        this._service.toasterService({ type: 'error', msg: resp?.response?.message });
      }
    });
  }
  ngOnDestroy(): void {
    this._entityInsightsStatisticsSubscription?.unsubscribe();
    this._entityInsightsAttributeSubscription?.unsubscribe();  
  }
  private _getEntityInsightsAttribute() {
    const reqData = {
      entityId: this.tabData?.entityId,
      attribute: this.tabData?.attribute ? this.tabData?.attribute : 'coordinates',
      to: this._leftSideStatData?.dataTill,
      from: this._leftSideStatData?.dataFrom
    };
    this._entityInsightsAttributeSubscription = this._entityService.entityInsightsAttribute(reqData).subscribe((dataResp: any) => {
      if (dataResp['status']) {
        if (dataResp['response']['data']) {
          this.attributeDataList = [];
          this.masterLeafletData = [];
          const attributeData = dataResp['response']['data']['attributes'];
          const enitityCords = dataResp['response']['data']['coordinates'];
          // enitityCords = [
          //   {
          //     "lat": 8.537545346659485,
          //     "long": 76.88186293551199
          //   },
          //   {
          //     "lat": 8.537545346659485,
          //     "long": 76.88186293551199
          //   },
          //   {
          //     "lat": 8.537545346659485,
          //     "long": 76.88186293551199
          //   },
          //   {
          //     "lat": 8.537545346659485,
          //     "long": 76.88186293551199
          //   }];
          if (enitityCords) {
            this.masterLeafletData = [{
              polygonData: enitityCords.map(({ lat, long }) => { return [lat, long] })
            }];
          }
          else {
            this.masterLeafletData = [];
          }

          // this.attributeData = {
          //   "throttle": [
          //     {
          //       "name": "throttle",
          //       "value": "19.0",
          //       "timestamp": "2023-01-13T11:39:13+0530"
          //     },
          //     {
          //       "name": "throttle",
          //       "value": "19.0",
          //       "timestamp": "2023-01-13T11:38:13+0530"
          //     },
          //     {
          //       "name": "throttle",
          //       "value": "19.0",
          //       "timestamp": "2023-01-13T11:37:13+0530"
          //     },
          //     {
          //       "name": "throttle",
          //       "value": "19.0",
          //       "timestamp": "2023-01-13T11:36:13+0530"
          //     }
          //   ]
          // }
          if (attributeData) {
            Object.keys(attributeData).forEach(element => {
              let attributeLineData = {
                x: attributeData[element].map(({ timestamp }) => new Date(timestamp)),
                y: attributeData[element].map(({ value }) => value),
                mode: 'lines+markers',
                connectgaps: true,
                title: '',
                tabTitle: '',
                margin: { l: 30, r: 10, b: 15, t: 0 },
                width: 700,
                barColor: 'white',
                name: 'Instantaneous Data',
                legend: true,
              };
              attributeLineData.tabTitle = element;
              this.attributeDataList.push(attributeLineData);
            });
          }
          else {
            this.attributeDataList = [];
          }
        } else {
          this.attributeDataList = [];
          this.masterLeafletData = [];
        }
      } else {
        this.attributeDataList = [];
        this.masterLeafletData = [];
        this._service.toasterService({ type: 'error', msg: dataResp?.response?.message });
      }
    })
  }
  private _tabChanged(event: any) {
    this._tabIndex = event.index;
  }
}
